import { AssociatedPersonnelThemeModeConfig } from './types';

const dark: AssociatedPersonnelThemeModeConfig = {
  associatedPersonnel: {},
};

export default dark;
